// extracted by mini-css-extract-plugin
export var container = "_hl-0";
export var content = "_hl-3";
export var customerTitle = "_hl-4";
export var empty = "_hl-5";
export var gray = "_hl-6";
export var header = "_hl-7";
export var info = "_hl-8";
export var loading = "_hl-2";
export var loadingCard = "_hl-9";
export var oneLine = "_hl-a";
export var personName = "_hl-e";
export var pillContainer = "_hl-b";
export var selected = "_hl-1";
export var text = "_hl-c";
export var twoLines = "_hl-d";
export var unread = "_hl-f";
export var unreadIndicator = "_hl-g";